export const  tableColumnData = [
    { label: "流程编号", prop: "appliCode", align: "center", width: 180, type: "CUSTOM", fixed: "left" },
    { label: "流程类型", prop: "approveType", align: "center" },
    { label: "流程标题", prop: "titleContent", align: "center" },
    { label: "流程日期", prop: "applyTimeStr", align: "center" },
    { label: "申请人", prop: "user", align: "center" },
    { label: "一级部门", prop: "deptment", align: "center" },
    {
      label: "操作",
      prop: "operation",
      type: "CUSTOM",
      align: "center",
      fixed: "right",
      width: 100,
    },
  ]